<template>
  <ItemListCollectionWrapper
    :collectionModule="$options.SharedFolderCollection"
    defaultSortBy="name"
    :refreshKey="refreshKey"
    :rowsPerPageLocalStorageKey="$options.rowsPerPageLocalStorageKey"
  >
    <template
      v-slot="slotProps"
    >
      <ItemListPagination
        :class="{'emptySharedFoldersList':hasEmptySharedFoldersListClass(slotProps)}"
        :columns="$options.columns"
        :currentPageNum="slotProps.currentPageNum"
        :isLoading="slotProps.loading"
        :itemComponent="$options.SharedFolderRow"
        :rowsPerPage="slotProps.rowsPerPage"
        :showEmptyState="!slotProps.loading && slotProps.showEmptyState"
        :sortBy="slotProps.sortBy"
        :sortDirection="slotProps.sortDirection"
        :tableData="slotProps.tableData"
        :totalCount="slotProps.totalCount"
        @pageChange="slotProps.handlePageChange"
        @sortColumn="slotProps.handleSortColumn"
      >
        <template v-slot:toolbar>
          <Toolbar
            :searchTerm="slotProps.getSearchTerm"
            :shouldFocusSearch="slotProps.shouldFocusSearch"
            @triggerSearch="slotProps.handleEnterSearchTerm"
          />
        </template>
        <template v-slot:emptyState>
          <NoSearchResults
            :src="$options.noResultsIllustration"
            @click="slotProps.clearSearchTerm"
          />
        </template>
      </ItemListPagination>
    </template>
  </ItemListCollectionWrapper>
</template>

<script>
import {
  ItemListPagination,
  NoSearchResults,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import Constants, {
  LocalStorageConsts,
} from 'client/util/Constants';
import ItemListCollectionWrapper from 'client/components/ItemList/ItemListCollectionWrapper.vue';
import SharedFolderRow from 'client/PasswordManager/SharedFolders/SharedFoldersItemListRow.vue';
import Toolbar from 'client/PasswordManager/SharedFolders/SharedFoldersItemListToolbar.vue';

const SharedFolderCollection = 'SharedFolderCollection';
const { noResultsIllustration } = Constants;

const { Column } = Types;
const columns = [
  Column({
    label: 'Name',
    dataFieldName: 'name',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'Users With Access',
    dataFieldName: 'usersWithAccess',
    sortable: false,
    width: '1fr',
  }),
  Column({
    label: 'Date Created',
    dataFieldName: 'createdAt',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: 'Password Health',
    dataFieldName: 'score',
    sortable: false,
    width: '1fr',
  }),
];

export default {
  name: 'SharedFoldersItemList',

  components: {
    ItemListPagination,
    ItemListCollectionWrapper,
    NoSearchResults,
    Toolbar,
  },

  columns,
  noResultsIllustration,
  rowsPerPageLocalStorageKey: LocalStorageConsts.sharedFoldersRowsPerPage,
  SharedFolderRow,
  SharedFolderCollection,

  computed: {
    ...mapGetters(SharedFolderCollection, {
      refreshKey: 'refreshKey',
    }),
  },

  destroyed() {
    this.resetCollection();
  },

  methods: {
    ...mapActions(SharedFolderCollection, [
      'resetCollection',
    ]),

    hasEmptySharedFoldersListClass(slotProps) {
      return slotProps.showEmptyState || slotProps.loading;
    },
  },
};
</script>

<style scoped>
.emptySharedFoldersList {
  /* @todo: remove when fixed from ui-components */
  min-height: 550px;
}
</style>
